import { Textarea } from '@headlessui/react'
import ctl from '@netlify/classnames-template-literals'
import { ValidationError } from '@tanstack/react-form'
import { ReactNode } from 'react'
import { GenericField, GenericFieldSizing } from './generic'
import { MagicSwirl } from './magic-swirl'

export type LargeTextFieldProps = {
	label: string
	value: string
	onChange: (value: string) => void
	onBlur?: () => void
	hint?: ReactNode
	isGenerating?: boolean
	errors?: Array<ValidationError>
	disabled?: boolean
	isWaiting?: boolean
	sizing?: GenericFieldSizing
}

export function LargeTextField(
	{
		label,
		value,
		onChange,
		onBlur = () => {},
		hint,
		isGenerating = false,
		errors = [],
		disabled = false,
		isWaiting = false,
		sizing = 'medium',
	}: LargeTextFieldProps,
) {
	const inputClassName = ctl(
		`
    block
	rounded-md ring-1 ring-grey-100 p-2 w-full
	border-none border-transparent 
	focus:border-transparent 
	focus-visible:border-transparent
	focus:outline-none
	focus-visible:outline-none
	focus-visible:ring-blue-500
	text-grey-800
    min-h-[100px]
	transition-shadow
	${isGenerating ? 'text-transparent cursor-wait bg-purple-50/50' : 'text-grey-800 bg-white'}
	${disabled ? 'opacity-50 cursor-not-allowed' : ''}
	${isWaiting ? 'opacity-50 cursor-wait' : ''}
	`,
	)

	return (
		<GenericField label={label} errors={errors} hint={hint} sizing={sizing}>
			<div className="focus-within:ring-4 ring-blue-100 rounded-md w-full whitespace-normal relative">
				<Textarea
					value={value}
					onChange={(e) => onChange(e.target.value)}
					onBlur={onBlur}
					className={inputClassName}
					disabled={isGenerating || disabled || isWaiting}
				/>
				{isGenerating ? <MagicSwirl /> : null}
			</div>
		</GenericField>
	)
}
